//@flow
//Action Type Registered
export const MORPHEUS_INV_SUBMIT_SUCCESS='MORPHEUS_INV_SUBMIT_SUCCESS'
export const MORPHEUS_INV_SUBMIT_ERROR='MORPHEUS_INV_SUBMIT_ERROR'
export const MORPHEUS_INV_SUBMITTED_COMPLETED='MORPHEUS_INV_SUBMITTED_COMPLETED'
export const MORPHEUS_EDIT_VERIFY_FORM_DATA_SUCCESS='MORPHEUS_EDIT_VERIFY_FORM_DATA_SUCCESS'
export const MORPHEUS_EDIT_VERIFY_FORM_DATA_ERROR='MORPHEUS_EDIT_VERIFY_FORM_DATA_ERROR'
export const MORPHEUS_UPDATE_FORM_ERROR='MORPHEUS_UPDATE_FORM_ERROR'
export const REFRESH_MORPHEUS_VENDORS_SUCCESS='REFRESH_MORPHEUS_VENDORS_SUCCESS'
export const REFRESH_MORPHEUS_VENDORS_ERROR='REFRESH_MORPHEUS_VENDORS_ERROR'



// WEBPACK FOOTER //
// ./src/redux/morpheus/actionTypes.js